import React, { useState, useEffect } from "react";
import { ThreeCircles } from "react-loader-spinner";
import "./ChefAddMenuModal.css";
import ItemDetails from "./ItemDetails";
import ItemCategory from "./ItemCategory";
import ItemAvailability from "./ItemAvailability";
import ItemPrice from "./ItemPrice";
import ItemImage from "./ItemImages";
import GetAPI from "../../APICalls/GetAPI";
import { v4 as uuidv4 } from "uuid";
import PutAPI from "../../APICalls/PutAPI";

const ChefEditMenuModal = ({ showEdit, handleAddClose, selectedChefData, menuID }) => {
  const [itemDetails, setItemDetails] = useState({ name: "", description: "" });
  const [itemCategory, setItemCategory] = useState(selectedChefData.isXpress
      ? {
          category: "",
          forCategories: [],
          menuCategory: [],
          foodType: { imageUrl: "", title: "", value: "" },
          foodStyle: "",
        }
      : {
          menuCategory: [],
          foodType: { imageUrl: "", title: "", value: "" },
          foodStyle: "",
        });
   const [itemAvailability, setItemAvailability] = useState(() => {
     return {
       isPreOrder: false,
       itemForever: false,
       menuTypes: [],
       isAllDaySelected: false,
       availabilityPlatform: "Homeal App",
       ...(selectedChefData.isXpress ? {} : { orderBy: "" })
     };
   });
  const [itemPrice, setItemPrice] = useState({ chefPrice: 0, itemPrice: 0, chefDiscount: 0 });
  const [itemImage, setItemImage] = useState("N/A");
  const [currentStep, setCurrentStep] = useState("Item Details");
  const [loading, setLoading] = useState(false);
  const [foodstyles, setFoodStyles] = useState([]);
  const [menuCategories, setMenuCategories] = useState([]);
  const [podCategories, setPodCategories] = useState([]);
  const [menuData, setMenuData] = useState("");

  const ENVIRONMENT = process.env.REACT_APP_NODE_ENV;
  let utilityApi, menuAPI;
  if (ENVIRONMENT === "PRODUCTION") {
    utilityApi = process.env.REACT_APP_PROD_UTILITY;
    menuAPI = process.env.REACT_APP_PROD_CHEFMENU;
  } else {
    utilityApi = process.env.REACT_APP_DEV_UTILITY;
    menuAPI = process.env.REACT_APP_DEV_CHEFMENU;
  }

  useEffect(() => {
   const COMPLETEUTILITYURL = utilityApi + "?type=ALL";
    GetAPI(COMPLETEUTILITYURL)
      .then((res) => {
        if (res.data.statusCode === 200) {
          setFoodStyles(res.data.body[1].value);
          setMenuCategories(res.data.body[2].value);
          setPodCategories(res.data.body[23].value);
          setLoading(false);
        } else {
          console.log("Error occurred. Error =" + res);
          setLoading(false);
          alert("Failed to get utility ");
        }
      })
      .catch((e) => {
        console.log("Error occurred. Error =" + e);
        setLoading(false);
        alert("Failed to get utility ");
      });

      const COMPLETE_MENU_URL = menuAPI + `?menuID=${menuID}`;
      GetAPI(COMPLETE_MENU_URL)
        .then((res) => {
          if (res.data.statusCode === 200) {
            const response = res.data;
            setMenuData(res.data.body)
            setItemDetails({
                name: response.body.itemName,
                description: response.body.itemDescription,
                imageUrl: response.body.imageUrl,
              });
              setItemCategory({
                category: response.body.category ? response.body.category : "",
                forCategories: response.body.forCategories ? response.body.forCategories : [],
                menuCategory: response.body.menuCategories,
                foodType: {
                  imageUrl: ReturnItemType(response.body),
                  title:
                    response.body.itemType.toUpperCase() === "VEGETARIAN"
                      ? "Veg"
                      : response.body.itemType.toUpperCase() === "NONVEGETARIAN"
                      ? "Non Veg"
                      : "Egg",
                  value: response.body.itemType,
                },
                foodStyle: response.body.menuTags.join(","),
              });
              setItemAvailability({
                orderBy: response.body.orderBy,
                isPreOrder:
                  response.body.isPreOrder !== undefined
                    ? response.body.isPreOrder
                    : null,
                itemForever: response.body.itemForever,
                menuTypes: response.body.menuType,
                isAllDaySelected: response.body.menuType.includes("All Day")
                  ? true
                  : false,
                  availabilityPlatform: response.body.isBoth ? "Both" : response.body.isSaas ? "Saas Website" : "Homeal App"
              });
              setItemPrice({
                chefPrice: response.body.chefCost,
                chefDiscount: response.body.chefDiscount,
                itemPrice: response.body.itemPrice
              });
              setItemImage(response.body.imageUrl)
              setLoading(false);
          } else {
            console.log("Error occurred. Error =" + res);
            setLoading(false);
            alert("Failed to get MenuDetails ");
          }
        })
        .catch((e) => {
          console.log("Error occurred. Error =" + e);
          setLoading(false);
          alert("Failed to get utility ");
        });
  }, []);

  const handleSubmit = () => {
    if (itemDetails.name == "" || itemDetails.description == "") {
      alert("Please enter item name and description");
      setCurrentStep("Item Details");
      return;
    }
    const categoryCondition = selectedChefData.isXpress ? itemCategory?.category === "" : itemCategory?.menuCategory?.length === 0
    if (
      categoryCondition || itemCategory.foodStyle === "" || itemCategory.foodType.value === ""
    ) {
      alert("Please fill all fields");
      setCurrentStep("Item Category");
      return;
    }
    if (
      selectedChefData.isXpress && itemCategory.category.toUpperCase() === "ADD ONS" && itemCategory.forCategories.length == 0
    ) {
      alert("Please add for categories");
      setCurrentStep("Item Category");
      return;
    }

    if (itemAvailability?.menuTypes?.length === 0) {
      alert("Please fill all fields");
      setCurrentStep("Item Availability");
      return;
    }
    if (parseInt(itemPrice.chefDiscount) >= parseInt(itemPrice.chefPrice)) {
      alert("Price should be greater than discount");
      return;
    }
    setLoading(true);
    const dataToPut = {
      userID: selectedChefData.userID,
      itemID: uuidv4(),
      menuID: menuID,
      itemName: itemDetails.name,
      itemDescription: itemDetails.description,
      itemType: itemCategory.foodType.value,
      menuTags: itemCategory.foodStyle.split(","),
      menuCategories: itemCategory.menuCategory,
      menuType: itemAvailability.menuTypes,
      isPreOrder: itemAvailability.isPreOrder,
      itemForever: itemAvailability.itemForever,
      chefCost: itemPrice.chefPrice,
      imageUrl: "N/A",
      isHomealItem: false,
      appVersion: 332,
      imageUrl: itemImage,
      isSaas:
        selectedChefData.saasUser &&
        itemAvailability.availabilityPlatform?.toUpperCase() === "SAAS WEBSITE",
      isBoth:
        selectedChefData.saasUser &&
        itemAvailability.availabilityPlatform?.toUpperCase() === "BOTH",
    };

    if(selectedChefData.isXpress){
      dataToPut["isXpress"] = true;
      dataToPut["category"] = itemCategory.category;
      dataToPut["forCategories"] = itemCategory.forCategories;
      dataToPut["itemPrice"] = itemPrice.itemPrice;
    }else {
      dataToPut["chefDiscount"] = itemPrice.chefDiscount;
      dataToPut["orderBy"] = itemAvailability.orderBy;
    }


    PutAPI(menuAPI, dataToPut)
      .then((res) => {
        if (res.data.statusCode === 200) {
          setMenuData(res.data.body)
          alert("Successfully updated menu!!! ");
          goToNextStep("Item Price")
        } else {
          alert("Failed to edit menu!!! ");
          console.log(res);
        }
        setLoading(false);
      })
      .catch((e) => {
        alert("Failed to edit menu!!! ");
        console.log(e);
        setLoading(false);
      });
  };

  const goToNextStep = (step) => {
    const currentIndex = STEPS.findIndex((s) => s?.id.toUpperCase() === step.toUpperCase());
    if (currentIndex !== -1 && currentIndex < STEPS.length - 1) {
      setCurrentStep(STEPS[currentIndex + 1].id);
    }
  };

  const goBackToPreviousStep = () => {
    const currentIndex = STEPS.findIndex((s) => s?.id.toUpperCase() === currentStep?.toUpperCase());
    if (currentIndex > 0) {
      setCurrentStep(STEPS[currentIndex - 1].id);
    }
  };

  const handleDiscard = () => {
    const stepsToGoBack = [
      "ITEM CATEGORY",
      "ITEM AVAILABILITY",
      "ITEM PRICE",
      "ITEM IMAGE"
      ];
      
      if (currentStep.toUpperCase() === "ITEM DETAILS") {
      handleAddClose();
      } else if (stepsToGoBack.includes(currentStep.toUpperCase())) {
      goBackToPreviousStep();
      }
  };

  const STEPS = [
    {
      id: "Item Details",
      component: (
        <ItemDetails
          data={itemDetails}
          onChange={setItemDetails}
          onNext={() => goToNextStep("Item Details")}
          onDiscard={handleDiscard}
        />
      ),
    },
    {
      id: "Item Category",
      component: (
        <ItemCategory
          data={itemCategory}
          onChange={setItemCategory}
          foodstyles={foodstyles}
          menuCategories={menuCategories}
          podCategories={podCategories}
          xpressChef={selectedChefData.isXpress}
          onNext={() => goToNextStep("Item Category")}
          onDiscard={handleDiscard}
        />
      ),
    },
    {
      id: "Item Availability",
      component: (
        <ItemAvailability
          data={itemAvailability}
          onChange={setItemAvailability}
          saasUser={selectedChefData.saasUser}
          xpressChef={selectedChefData.isXpress}
          onNext={() => goToNextStep("Item Availability")}
          onDiscard={handleDiscard}
        />
      ),
    },
    {
      id: "Item Price",
      component: (
        <ItemPrice
          data={itemPrice}
          onChange={setItemPrice}
          onSubmit={handleSubmit}
          onImageUpdate={() => goToNextStep("Item Price")}
          onDiscard={handleDiscard}
          xpressChef={selectedChefData.isXpress}
        />
      ),
    },
    {
      id: "Item Image",
      component: (
        <ItemImage
          data={itemImage}
          onChange={setItemImage}
          chefID={selectedChefData.userID}
          menuData={menuData}
          onDiscard={handleDiscard}
          handleAddClose={handleAddClose}
          imageValue={itemImage}
        />
      ),
    },
  ];

  const RenderProgress = ({ title, isActive }) => (

    <div className={`progress-item ${isActive ? "active" : ""}`} onClick={() => setCurrentStep(title) }>
      <p>{title}</p>
      {isActive && <div className="progress-bar-active"></div>}
    </div>
  );

  const ReturnItemType = (item) => {
    switch (item?.itemType?.toUpperCase()) {
      case "VEGETARIAN":
        return "https://d2nahbmqd5vvug.cloudfront.net/appdata/VegIcon.png";
      case "NONVEGETARIAN":
        return "https://d2nahbmqd5vvug.cloudfront.net/appdata/NonVegIcon.png";
      default:
        return "https://d2nahbmqd5vvug.cloudfront.net/appdata/EggIcon.png";
    }
  };

  return (
    <div className="EditMenu">
    <div
      className={`modal fade ${showEdit ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ display: showEdit ? "block" : "none" }}
    >
           <div className="modal-dialog"
    role="document">
        <div className="modal-content">
          {loading && (
            <div className="spinnerContainer">
              <div className="spinner">
                <ThreeCircles
                  color="blue"
                  height={110}
                  width={110}
                  ariaLabel="three-circles-rotating"
                />
              </div>
            </div>
          )}
          <div className="modal-header">
            <h5
              className="modal-title"
              style={{ color: "black", fontSize: "1.25rem" }}
            >{`You are editing ${itemDetails.name}`}</h5>
            <button type="button" className="close" onClick={handleAddClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="progress-bar-container">
              {STEPS.map((step) => (
                <RenderProgress
                  key={step.id}
                  title={step.id}
                  isActive={currentStep === step.id}
                />
              ))}
            </div>
            {STEPS.find((s) => s.id === currentStep).component}
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default ChefEditMenuModal;
